import BillDesign from './BillDesign';

export default BillDesign;



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/bill-design/index.jsx